/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { EngagementType } from "./EngagementType";
import {
  EngagementTypeFromJSON,
  EngagementTypeFromJSONTyped,
  EngagementTypeToJSON,
  EngagementTypeToJSONTyped,
} from "./EngagementType";

/**
 *
 * @export
 * @interface CreateTeamMemberRequest
 */
export interface CreateTeamMemberRequest {
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  personalEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  personalPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  mailingAddress?: string | null;
  /**
   *
   * @type {number}
   * @memberof CreateTeamMemberRequest
   */
  birthdayMonth?: number | null;
  /**
   *
   * @type {number}
   * @memberof CreateTeamMemberRequest
   */
  birthdayDay?: number | null;
  /**
   *
   * @type {LocalDate}
   * @memberof CreateTeamMemberRequest
   */
  joinDate?: LocalDate | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateTeamMemberRequest
   */
  teamIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  legalFullName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  jobTitle?: string | null;
  /**
   *
   * @type {EngagementType}
   * @memberof CreateTeamMemberRequest
   */
  engagementType?: EngagementType | null;
  /**
   *
   * @type {CurrencyCode}
   * @memberof CreateTeamMemberRequest
   */
  currency?: CurrencyCode | null;
  /**
   *
   * @type {LocalDate}
   * @memberof CreateTeamMemberRequest
   */
  endDate?: LocalDate | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateTeamMemberRequest
   */
  githubIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CreateTeamMemberRequest
   */
  applicationId?: string | null;
}

/**
 * Check if a given object implements the CreateTeamMemberRequest interface.
 */
export function instanceOfCreateTeamMemberRequest(
  value: object,
): value is CreateTeamMemberRequest {
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("firstName" in value) || value["firstName"] === undefined) return false;
  if (!("lastName" in value) || value["lastName"] === undefined) return false;
  if (!("teamIds" in value) || value["teamIds"] === undefined) return false;
  if (!("githubIds" in value) || value["githubIds"] === undefined) return false;
  return true;
}

export function CreateTeamMemberRequestFromJSON(
  json: any,
): CreateTeamMemberRequest {
  return CreateTeamMemberRequestFromJSONTyped(json, false);
}

export function CreateTeamMemberRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateTeamMemberRequest {
  if (json == null) {
    return json;
  }
  return {
    email: json["email"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    personalEmail:
      json["personalEmail"] == null ? undefined : json["personalEmail"],
    personalPhone:
      json["personalPhone"] == null ? undefined : json["personalPhone"],
    mailingAddress:
      json["mailingAddress"] == null ? undefined : json["mailingAddress"],
    birthdayMonth:
      json["birthdayMonth"] == null ? undefined : json["birthdayMonth"],
    birthdayDay: json["birthdayDay"] == null ? undefined : json["birthdayDay"],
    joinDate: json["joinDate"] == null ? undefined : json["joinDate"],
    teamIds: json["teamIds"],
    legalFullName:
      json["legalFullName"] == null ? undefined : json["legalFullName"],
    jobTitle: json["jobTitle"] == null ? undefined : json["jobTitle"],
    engagementType:
      json["engagementType"] == null
        ? undefined
        : EngagementTypeFromJSON(json["engagementType"]),
    currency:
      json["currency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["currency"]),
    endDate: json["endDate"] == null ? undefined : json["endDate"],
    githubIds: json["githubIds"],
    applicationId:
      json["applicationId"] == null ? undefined : json["applicationId"],
  };
}

export function CreateTeamMemberRequestToJSON(
  json: any,
): CreateTeamMemberRequest {
  return CreateTeamMemberRequestToJSONTyped(json, false);
}

export function CreateTeamMemberRequestToJSONTyped(
  value?: CreateTeamMemberRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    personalEmail: value["personalEmail"],
    personalPhone: value["personalPhone"],
    mailingAddress: value["mailingAddress"],
    birthdayMonth: value["birthdayMonth"],
    birthdayDay: value["birthdayDay"],
    joinDate: value["joinDate"],
    teamIds: value["teamIds"],
    legalFullName: value["legalFullName"],
    jobTitle: value["jobTitle"],
    engagementType: EngagementTypeToJSON(value["engagementType"]),
    currency: CurrencyCodeToJSON(value["currency"]),
    endDate: value["endDate"],
    githubIds: value["githubIds"],
    applicationId: value["applicationId"],
  };
}
